import { request } from '@/utils/infrastructure/communication';

const BASE_URL = '/notification';

/** @returns {Promise<{ publicKey: string }>} VAPID public key in base64url. */
export const fetchPushPublicKey = () => {
  return request(`${BASE_URL}/push/publicKey`, { suppressErrorNotification: true });
};

/**
 * The user comes from the token; the backend upserts by endpoint so the same
 * browser moves to whoever signs in next.
 * @param {{ endpoint: string, keys: { p256dh: string, auth: string } }} subscription
 */
export const registerPushDevice = (subscription) => {
  return request.post(`${BASE_URL}/device`, {
    data: {
      endpoint: subscription.endpoint,
      keys: subscription.keys,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    },
    suppressErrorNotification: true,
  });
};

/** @param {string} endpoint */
export const unregisterPushDevice = (endpoint) => {
  if (!endpoint) return Promise.resolve();
  return request.delete(`${BASE_URL}/device`, {
    data: { endpoint },
    suppressErrorNotification: true,
  });
};
